export const PLANNER_DATE_FORMAT = 'YYYY-MM-DD';
export const PLANNER_WEEK_FORMAT = 'YYYY-WW';
export const PLANNER_TIME_FORMAT = 'HH:mm:ss';
export const PLANNER_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
export const ROUTE_DATE_TIME_FORMAT = PLANNER_DATE_FORMAT + '-HH-mm';
export const ROUTE_DATE_FORMAT = PLANNER_DATE_FORMAT;
export const PLANNER_ROOT_ROUTE = 'planner-home';
export const DEFAULT_PLANNER_EVENT_DURATION = '01:00';
export const PLANNER_START_HOUR = 7;
export const PLANNER_END_HOUR = 20;
export const PLANNER_TIME_CONFIG = {
  minTime: { hours: PLANNER_START_HOUR, minutes: 0 },
  maxTime: { hours: PLANNER_END_HOUR, minutes: 0 },
  minutesIncrement: 15,
};